import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {GetServerSideProps} from 'next'
import {useEffect, useState, useRef, ReactEventHandler} from 'react'
//@ts-ignore
import {useLottie} from '@/hooks/useLottie'
import classNames from 'classnames'
import {useActivity} from '@/pages/activity/tenyears'
import {ActivityId, CombineImage_Map, IMAGE_MAP, TenAcTitle} from '@/constants/activityCdn'
import TitleBar from '@/components/TitleBar'
import {Swiper, Toast} from 'gotu-ui'
import {Mission, MissionModule, SubActivityModule, doMission} from '@/service/activity'
import {useGlobal, useUaParam} from '@/pages/_app'
import {openWindow, toLoginPage} from '@/plugins/bridge'
import {useCombine} from '@/pages/activity/tenyears/combine'
import {MissonTypeEnum} from '@/service/types/enum'
import {haboClickReport} from '@/plugins/habo'
import Share from '../share'
const styles = require('./style.module.less')
interface ModuleProps {
  missionModule: MissionModule
  mainRef: any,
  activityPhase:number
  scrollModule: (type: 'main' | 'child') => void,
}

const SignButton_Map:Record<number, string> = {0: '签到', 1: '已签到', 2: '已完成'}
const Button_Map: Record<number, string> = {0: '做任务', 1: '已完成', 3: '领奖励'}
const Main = (props: ModuleProps) => {
    const {
        missionModule,
        mainRef,
        activityPhase,
        scrollModule,
    } = props
    const {
        isExpired,
        signMission,
        missionList,
    } = missionModule
    const [time, setTime] = useState('')
    const {
        isApp,
        visualCenterPosition = 0,
        isLogin,
        fromId,
        source,
    } = useUaParam()
    const {refreshUaParam} = useGlobal()
    const {
        popData,
        setPopData,
        popVisible,
        setPopVisible,
        getData,
        data,
        setData,
        swiperRef,
    } = useCombine()
    const [shareVisible, setShareVisible] = useState(false)
    const [shareTask, setShareTask] = useState<Mission>()
    const goUrl = (item: SubActivityModule) => {
        const {
            jumpUrl,
            isLock,
            lockToast,
        } = item
        if (isLock) {
            return Toast.show(lockToast || '视频未解锁，请耐心等待')
        }
        jumpToUrl(jumpUrl)
    }
    const jumpToUrl = (url: string, showStatus?:boolean) => {
        if (isApp) {
            openWindow(url, 'hide', showStatus ? 'show' : 'hide')
        } else {
            // if (isIOS) {
            //     window.location.href = url
            // } else {
            window.open(url)
            // }
        }
    }
    const goTask = async (task: Mission) => {
        if (!isLogin || !data?.isLogin) {
            if (isApp) {
                toLoginPage(() => {
                    refreshUaParam()
                    getData()
                })
            } else {
                const backUrl = location.href
                const url = `${backUrl}${backUrl.indexOf('?') > -1 ? '&' : '?'}isLoginBack=1`
                location.href = `${location.origin}/login?redirect=${encodeURIComponent(url)}&forceBindMobile=1`
            }
            return
        }
        const {missionStatus, missionType} = task
        if (missionStatus === 1) return Toast.show('今日任务已完成~')
        if (missionStatus === 3) {
            getReward(task)
            return
        }
        haboClickReport('十周年做任务', {source, taskid: missionType, activity_id: ActivityId})
        // 非签到任务
        // 社区20s,学币商城20秒,资料20秒,菁英计划20秒,即时倾听20秒
        if (missionType === MissonTypeEnum.community_20
        || missionType === MissonTypeEnum.coin_mall ||
        missionType === MissonTypeEnum.listen_20 ||
        missionType === MissonTypeEnum.material_20 ||
          missionType === MissonTypeEnum.qingying_20) {
            if (missionType === MissonTypeEnum.community_20) {
                task.jumpUrl && jumpToUrl(task.jumpUrl, true)
            } else {
                task.jumpUrl && jumpToUrl(task.jumpUrl)
            }
            return
        }
        // 视频跳转到子模块
        if (missionType === MissonTypeEnum.video) {
            scrollModule('child')
            let last = 4
            if (data) {
                const {subActivityModuleList} = data
                last = subActivityModuleList.length - 1
            }
            swiperRef.current?.swipeTo(last)
            return
        }
        // 分享
        if (missionType === MissonTypeEnum.share) {
            setShareTask(task)
            setShareVisible(true)
            return
        }
        let params = {fromId, missionType, operationType: missionStatus === 3 ? 2 : 1}
        // ios由于安全策略，window.open会被拦截，必须通过用户的click事件触发，因此延迟50ms,在发起接口之后再打开新页面
        const t1 = setTimeout(() => {
            task.jumpUrl && jumpToUrl(task.jumpUrl)
            clearTimeout(t1)
        }, 50)
        const res = await doMission(params)
        const {code, msg} = res
        if (code !== SUCCESS_CODE) return Toast.show(msg || '数据获取失败，请刷新页面重试')
        getData()
    }
    // 领取奖励
    const getReward = async (task: Mission) => {
        const {missionStatus, missionType} = task
        let params = {fromId, missionType, operationType: missionStatus === 3 ? 2 : 1}
        const res = await doMission(params)
        const {code, msg} = res
        if (code !== SUCCESS_CODE) return Toast.show(msg || '数据获取失败，请刷新页面重试')
        setPopData(res.data)
        setPopVisible(true)
        if (res.data?.rewardInfo?.rewardType === 1) {
            // 碎片不刷新数据，刷新数据会跳过动画, 手动修改状态
            if (data) {
                const {missionModule} = data
                const {missionList} = missionModule
                const newMissionList = missionList.map((item: Mission) => {
                    return {...item, missionStatus: item.missionType === missionType ? 1 : item.missionStatus}
                })
                setData({
                    ...data,
                    missionModule: {...missionModule, missionList: newMissionList},
                })
            }
        } else {
            getData()
        }
        haboClickReport('十周年领取奖励', {source, taskid: missionType, activity_id: ActivityId})
    }
    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date()
            const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0)
            const diff = midnight.getTime() - now.getTime()
            if (diff > 0) {
                const hours = Math.floor(diff / (1000 * 60 * 60))
                const minutes = Math.floor((diff / (1000 * 60)) % 60)
                const seconds = Math.floor((diff / 1000) % 60)
                const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
                setTime(timeString)
            } else {
                getData()
                clearInterval(timer)
            }
        }, 1000)
        return () => {
            clearInterval(timer)
        }
    }, [])
    const goSign = async () => {
        if (!isLogin || !data?.isLogin) {
            if (isApp) {
                toLoginPage(() => {
                    refreshUaParam()
                    getData()
                })
            } else {
                const backUrl = location.href
                const url = `${backUrl}${backUrl.indexOf('?') > -1 ? '&' : '?'}isLoginBack=1`
                location.href = `${location.origin}/login?redirect=${encodeURIComponent(url)}&forceBindMobile=1`
            }
            return
        }
        const params = {fromId, missionType: signMission.missionType, operationType: 1}
        const res = await doMission(params)
        if (res.code === SUCCESS_CODE) {
            const {data} = res
            if (data?.rewardInfo) {
                setPopData(data)
                setPopVisible(true)
                haboClickReport('十周年领取奖励', {source, taskid: signMission.missionType, activity_id: ActivityId})
            }
            getData()
            haboClickReport('十周年签到', {source, activity_id: ActivityId, totalsigndays: signMission.userSignDays + 1})
        }
    }
    const signRewardClick = (value: Mission) => {
        const {signDays = 0} = value
        const {userSignDays} = signMission
        if (userSignDays >= signDays) return
        Toast.show(`再签到${signDays - userSignDays}天才能领取哦`)
    }
    const doShare = async () => {
        if (shareTask) {
            const {missionType, missionStatus} = shareTask
            let params = {fromId, missionType, operationType: missionStatus === 3 ? 2 : 1}
            const res = await doMission(params)
            if (res.success) {
                getData()
            }
        }
    }
    // 手动调整进度条，避免进度条看着不准
    const getProgress = () => {
        const {missionList, userSignDays} = signMission
        if (missionList.length === 0) return 0
        if (userSignDays === 0) return '0'
        if (userSignDays === 1) return '8%'
        const signDays = userSignDays
        const length = missionList.length - 1
        const equal = (100 / length).toFixed(2) || 0
        let progress = 0
        // 找到当前签到天数所在的区间
        for (let i = 1; i < missionList.length; i++) {
            const item = missionList[i]
            const nowSignDays = item.signDays || 0
            if (signDays === (nowSignDays || 0)) {
                progress = i * Number(equal)
                break
            }
            // 根据差值计算进度
            if (signDays < (item.signDays || 0)) {
                const pre = missionList[i - 1]
                const preSignDays = pre.signDays || 0
                const preProgress = (i - 1) * Number(equal)
                progress = preProgress + ((signDays - preSignDays) / (nowSignDays - preSignDays)) * Number(equal)
                break
            }
        }
        return `${progress}%`
    }
    const progress = getProgress()
    const MissionBox = () => {
        return (
            <div>
                <div className='f ac'>
                    <div>
                        <img
                            src={CombineImage_Map.sign_icon}
                            width={40}
                            height={40}
                        ></img>
                    </div>
                    <div className='f1 f ac jspace-between ml8'>
                        <div className={styles.content}>每日签到</div>
                        <div
                            onClick={goSign}
                            className={classNames(styles.btn, signMission.signButtonStatus !== 0 && styles.gray)}
                        >
                            { SignButton_Map[signMission.signButtonStatus]}
                        </div>
                    </div>
                </div>
                <div className='ml48 por mt6'>
                    <div className='f por z10 jspace-between'>
                        {signMission.missionList.map((item) => {
                            return (
                                <div
                                    className=' fc'
                                    key={item.title}
                                    onClick={() => signRewardClick(item)}
                                >
                                    <img
                                        className='w30 h30'
                                        src={item.iconUrl}
                                        width={120}
                                        height={120}
                                        // quality={100}
                                    ></img>
                                    <div className='#525461 fw600'>
                                        {item.signDays}
                                        天
                                    </div>
                                    <div className='#9698A1'>{ item.subTitle}</div>
                                </div>
                            )
                        })}
                    </div>
                    <div className={styles.progress}>
                        <div
                            style={{width: progress}}
                            className={styles.inner}
                        ></div>
                    </div>
                </div>
                <div className={styles.mainbox}>
                    {
                        missionList.map((item, index) => {
                            return (
                                <div
                                    className='f ac pb16 por mt16'
                                    key={index}
                                >
                                    <img
                                        className='w40 h40'
                                        src={item.iconUrl}
                                        width={160}
                                        height={160}
                                        // quality={100}
                                    ></img>
                                    <div className='f1 f ac jspace-between ml8'>
                                        <div className={styles.content}>
                                            <div>{ item.title}</div>
                                            <div className='fs12 fw400 #9698A1 mt4'>{ item.subTitle}</div>
                                        </div>
                                        <div className='fc shrink0'>
                                            <div
                                                onClick={() => goTask(item)}
                                                className={classNames(styles.btn, item.missionStatus === 1 && styles.gray)}
                                            >
                                                { Button_Map[item.missionStatus]}
                                            </div>
                                            {
                                                item.missionStatus === 3 && (
                                                    <div className='fs12 fw400 #9698A1 lh18 mt4'>{ time}</div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    {
                                        missionList.length - 1 > index && <div className={styles.line}></div>
                                    }
                                </div>
                            )
                        })
                    }
                </div>

                <Share
                    visible={shareVisible}
                    doShare={doShare}
                    close={() => setShareVisible(false)}
                ></Share>
            </div>
        )
    }
    if (activityPhase === 2) return null
    return (
        <div
            ref={mainRef}
            className={classNames({[styles.main]: true})}
        >

            <div className='w100% fc por'>
                <img
                    className='w100% hauto block'
                    src={CombineImage_Map.main_title}
                ></img>
                {/* <I
                    className='w100% hauto block'
                    width={343}
                    height={66}
                    src={CombineImage_Map.main_title}
                    quality={100}
                >
                </I> */}
            </div>
            <div className='bg#fff rdt0 rdl12 rdr12 pl16 pr16 mt-1'>
                <div className='mb12'>完成任务后会获得奖励，超过当天24点未领取会消失哦</div>
                {
                    activityPhase !== 2 && MissionBox()
                }
            </div>
        </div>
    )
}

export default Main
